export const configDaily = [
    { name: "name", label: "Nama\nCabang", options: { sort: false } },
    { name: "newProspect", label: "New\nProspek", options: { sort: false } },
    { name: "newProspectRate", label: "Rate\n%", options: { sort: false } },
    { name: "nonFU", label: "Non\nFU", options: { sort: false } },
    { name: "nonFURate", label: "Rate\n%", options: { sort: false } },
    { name: "ongoing", label: "On\nGoing", options: { sort: false } },
    { name: "ongoingRate", label: "Rate\n%", options: { sort: false } },
    { name: "pending", label: "Pending", options: { sort: false } },
    { name: "pendingRate", label: "Rate\n%", options: { sort: false } },
    { name: "deal", label: "Deal", options: { sort: false } },
    { name: "dealRate", label: "Rate\n%", options: { sort: false } },
    { name: "drop", label: "Drop", options: { sort: false } },
    { name: "dropRate", label: "Rate\n%", options: { sort: false } },
];

export const configMonitoringProspect = [
    { name: "namaCabang", label: "Nama\nCabang", options: { sort: false } },
    { name: "newProspect", label: "NEW\nPROSPEK", options: { sort: false } },
    { name: "newProspectRate", label: "rate%", options: { sort: false } },
    { name: "nonFU", label: "NON FU", options: { sort: false } },
    { name: "nonFURate", label: "rate%", options: { sort: false } },
    { name: "ongoing", label: "ONGOING", options: { sort: false } },
    { name: "ongoingRate", label: "rate%", options: { sort: false } },
    { name: "pending", label: "PENDING", options: { sort: false } },
    { name: "pendingRate", label: "rate%", options: { sort: false } },
    { name: "deal", label: "DEAL", options: { sort: false } },
    { name: "dealRate", label: "rate%", options: { sort: false } },
    { name: "drop", label: "DROP", options: { sort: false } },
    { name: "dropRate", label: "rate%", options: { sort: false } }
];

export const monthOptions = [
    {label: "Januari", value: 1},
    {label: "Februari", value: 2},
    {label: "Maret", value: 3},
    {label: "April", value: 4},
    {label: "Mei", value: 5},
    {label: "Juni", value: 6},
    {label: "Juli", value: 7},
    {label: "Agustus", value: 8},
    {label: "September", value: 9},
    {label: "Oktober", value: 10},
    {label: "November", value: 11},
    {label: "Desember", value: 12},
];

const currentYear = new Date().getFullYear();
export const yearOptions = Array.from({length: currentYear - 1990 + 1}, (_, i) => {
    const year = currentYear - i;
    return {
        label: String(year),
        value: year,
    };
});

